import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useOnboarding } from '../../contexts/OnboardingContext';
import { SparklesIcon, XMarkIcon } from '@heroicons/react/24/outline';

const OnboardingPrompt: React.FC = () => {
    const { showPrompt, startTour, skipTour } = useOnboarding();

    return (
        <AnimatePresence>
            {showPrompt && (
                <div className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center pointer-events-none p-4 sm:p-0">
                    {/* Backdrop */}
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="absolute inset-0 bg-black/40 backdrop-blur-sm pointer-events-auto"
                        onClick={skipTour}
                    />

                    {/* Modal Card */}
                    <motion.div
                        initial={{ opacity: 0, y: 50, scale: 0.95 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: 20, scale: 0.95 }}
                        className="relative pointer-events-auto bg-white/90 dark:bg-slate-900/90 backdrop-blur-xl border border-white/20 shadow-2xl rounded-3xl p-6 sm:p-8 max-w-sm w-full mx-auto"
                    >
                        <button
                            onClick={skipTour}
                            className="absolute top-4 right-4 p-2 rounded-full hover:bg-black/5 dark:hover:bg-white/10 transition-colors"
                        >
                            <XMarkIcon className="w-5 h-5 text-gray-500" />
                        </button>

                        <div className="flex flex-col items-center text-center">
                            <div className="w-16 h-16 rounded-full bg-primary-100 dark:bg-primary-900/30 flex items-center justify-center mb-6">
                                <SparklesIcon className="w-8 h-8 text-primary-600 animate-pulse" />
                            </div>

                            <h2 className="text-2xl font-black text-gray-900 dark:text-white mb-2">
                                Welcome to Maasai SightTrails
                            </h2>
                            <p className="text-gray-600 dark:text-gray-300 mb-8 leading-relaxed">
                                Let us help you discover your perfect safari experience. Would you like a brief guide to navigate our personalized tour options, or would you prefer to explore on your own?
                            </p>

                            <div className="flex flex-col sm:flex-row w-full gap-3">
                                <button
                                    onClick={skipTour}
                                    className="flex-[0.8] py-3 px-4 rounded-xl font-bold text-gray-500 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-slate-800 transition-all text-sm"
                                >
                                    Explore Independently
                                </button>
                                <button
                                    onClick={startTour}
                                    className="flex-[1.2] py-3 px-4 rounded-xl font-bold bg-primary-600 text-white shadow-lg shadow-primary-500/30 hover:bg-primary-700 hover:scale-105 transition-all text-sm"
                                >
                                    Start Guided Tour
                                </button>
                            </div>
                        </div>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    );
};

export default OnboardingPrompt;
